import React, { useEffect, useState } from "react";
import { getOrders, updateOrderStatus, deleteOrder, IMAGE_URL } from "../api/api";
import "../styles/Orders.css";

const Orders = ({ userId, adminData }) => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [orderMessage, setOrderMessage] = useState("");

  // If no userId is provided, assume admin view.
  const isAdminView = !userId;

  useEffect(() => {
    fetchOrders();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, adminData]);

  const fetchOrders = async () => {
    try {
      const response = await getOrders(userId);
      if (Array.isArray(response.data)) {
        // Sort orders in descending order (newest first)
        const sortedOrders = [...response.data].sort((a, b) => b.id - a.id);
        setOrders(sortedOrders);
      } else {
        console.error("Unexpected orders format:", response.data);
        setOrders([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError("Error fetching orders");
    }
  };

  const handleMarkDelivered = async (orderId) => {
    try {
      const response = await updateOrderStatus(orderId);
      alert(response.data.message || "Order updated successfully");
      fetchOrders();
    } catch (err) {
      console.error("Error updating order status:", err);
      setOrderMessage("Failed to update order.");
    }
  };

  const handleDeleteOrder = async (orderId) => {
    if (!window.confirm("Are you sure you want to delete this order?")) return;
    try {
      const response = await deleteOrder({ order_id: orderId });
      setOrderMessage(response.data.message || "Order deleted successfully");
      fetchOrders();
    } catch (err) {
      console.error("Error deleting order:", err);
      setOrderMessage("Failed to delete order.");
    }
  };

  return (
    <div className="orders-container">
      <h2>Orders</h2>
      {error && <p className="error">{error}</p>}
      {orderMessage && <p className="message">{orderMessage}</p>}
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <div className="orders-table-container">
          <table className="orders-table">
            <thead>
              <tr>
                
                <th>Order ID</th>
                <th>Table</th>
                <th>Type</th>
                <th>Status</th>
                <th>Payment Mode</th>
                <th>Payment Status</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                let details = [];
                try {
                  details = JSON.parse(order.order_details);
                } catch (e) {
                  try {
                    details = JSON.parse(order.order_details.replace(/\\"/g, '"'));
                  } catch (e2) {
                    console.error("Error parsing order details:", e2);
                  }
                }
                return (
                  <tr key={order.id}>
                    <td>{order.id}</td>
                    <td>{order.table_number ?? "—"}</td>
                    <td style={{ textTransform: "capitalize" }}>
                    {order.order_type}
                    </td>
                    <td>{order.status}</td>
                    <td>{order.payment_mode || "N/A"}</td>
                    <td>{order.payment_status || "Not Paid"}</td>
                    <td>
                      {details.map((item, index) => (
                        <div key={index} className="order-detail-item">
                          <img
                            src={`${IMAGE_URL}${item.image}`}
                            alt={item.name}
                            className="order-item-image"
                          />
                          <div className="order-item-info">
                            <p className="item-name">{item.name}</p>
                            <p className="item-price">&#8377;{Number(item.price).toFixed(2)}</p>
                            <p className="item-qty">Qty: {item.quantity}</p>
                          </div>
                        </div>
                      ))}
                    </td>
                    <td>
                      {order.status !== "Delivered" && (
                        <button
                          className="orders-btn mark-btn"
                          onClick={() => handleMarkDelivered(order.id)}
                        >
                          Mark as Delivered
                        </button>
                      )}
                      {isAdminView && (
                        <button
                          className="orders-btn delete-btn"
                          onClick={() => handleDeleteOrder(order.id)}
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
